import { api } from '@/lib/api-client';

export interface ConfigListEntry {
  jobTypeSlug: string;
  versionNumber: number;
  path: string;
  sha: string;
  // T6 shape note: populated ONLY on the latest-per-slug row; history rows
  // come back null by design (no lazy per-version fetch in v1).
  pushedAt: string | null;
}

export interface BrowseResult {
  configured: boolean;
  items: ConfigListEntry[];
  // T6 shape note: present (`true`) only when GitHub's listing was cut off —
  // omitted entirely otherwise, so existing consumers see no shape change.
  truncated?: boolean;
}

export interface ImportFinding {
  code: string;
  severity: 'error' | 'warn';
  message: string;
  linkTarget?: { tab: string; fieldName?: string };
}

export interface ImportResult {
  jobTypeId: string;
  errors: ImportFinding[];
  healedCount: number;
}

export function browse(): Promise<BrowseResult> {
  return api.get<BrowseResult>('/admin/config-import/browse');
}

export function importFromGithub(input: { path: string; targetName: string }): Promise<ImportResult> {
  return api.post<ImportResult>('/admin/config-import/from-github', input);
}

export function importUpload(input: { file: File; targetName: string }): Promise<ImportResult> {
  const form = new FormData();
  form.append('file', input.file);
  return api.upload<ImportResult>(`/admin/config-import/upload?targetName=${encodeURIComponent(input.targetName)}`, form);
}

export function recheck(jobTypeId: string): Promise<ImportResult> {
  return api.post<ImportResult>(`/admin/config-import/${jobTypeId}/recheck`);
}
